import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// import AvatarImage from "../assets/images/avatar.png";
import AvatarImage from "../assets/icons/helen.svg";
import { useEvent } from "../helpers/useEvent";

function AssistantAvatar() {
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [shakeAnimation, setShakeAnimation] = useState(false);
  const [interactedWith, setInteractedWith] = useState(false);
  const location = useLocation();

  const isPostPage = /\/(blog|guias)\/[^/]+\/[^/]+/.test(location.pathname);

  const toggleMenu = (isConsideredInteraction = true) => {
    setIsMenuVisible((prev) => !prev);
    if (isConsideredInteraction) {
      setInteractedWith(true);
      setShowMessage(false);
    }
  };

  const sendEvent = useEvent();

  const handleClick = (eventType, e, shouldOpenInNewTab = false) => {
    sendEvent(eventType);
    setInteractedWith(true);

    if (!shouldOpenInNewTab) {
      e.preventDefault();
      const url = e.currentTarget.href;
      setTimeout(() => {
        window.location.href = url;
      }, 100);
    }
  };

  // useEffect(() => {
  //   const menuTimer = setTimeout(() => {
  //     if (interactedWith) return () => clearTimeout(menuTimer);

  //     setIsMenuVisible(true);

  //     const messageTimer = setTimeout(() => {
  //       setIsMenuVisible(false);
  //       setShowMessage(true);

  //       const hideMessageTimer = setTimeout(() => {
  //         setShowMessage(false);
  //       }, 8000);

  //       return () => clearTimeout(hideMessageTimer);
  //     }, 27000);

  //     return () => clearTimeout(messageTimer);
  //   }, 3000);

  //   return () => clearTimeout(menuTimer);
  // }, [interactedWith]);

  // useEffect(() => {
  //   if (!interactedWith) {
  //     const shakeInterval = setInterval(() => {
  //       if (!interactedWith) {
  //         setShakeAnimation(true);

  //         const stopShakeTimer = setTimeout(() => {
  //           setShakeAnimation(false);
  //         }, 2000);

  //         return () => clearTimeout(stopShakeTimer);
  //       }
  //     }, 40000);

  //     return () => clearInterval(shakeInterval);
  //   }
  // }, [interactedWith]);

  useEffect(() => {
    if (!interactedWith) {
      const shakeTimer = setTimeout(() => {
        setShakeAnimation(true);

        const stopShakeTimer = setTimeout(() => {
          setShakeAnimation(false);
        }, 2000);

        return () => clearTimeout(stopShakeTimer);
      }, 20000);

      return () => clearTimeout(shakeTimer);
    }
  }, [interactedWith]);

  useEffect(() => {
    if (!interactedWith) {
      const messageTimer = setTimeout(() => {
        setShowMessage(true);

        const menuTimer = setTimeout(() => {
          setShowMessage(false);
          setIsMenuVisible(true);
        }, 20000);

        return () => clearTimeout(menuTimer);
      }, 40000);

      return () => clearTimeout(messageTimer);
    }
  }, [interactedWith]);

  // this to make the function available to other components
  useEffect(() => {
    const handleToggleMenuEvent = () => {
      toggleMenu(true);
    };

    window.addEventListener("toggleAssistantMenu", handleToggleMenuEvent);

    return () => {
      window.removeEventListener("toggleAssistantMenu", handleToggleMenuEvent);
    };
  }, []);

  return (
    <section className="fixed bottom-0 right-0 z-[50]">
      <div className="justify-end pb-4 pr-4 text-end md:pb-9 md:pr-9">
        {isMenuVisible && (
          <div id="contact" className="space-y-2 text-sm flex flex-col justify-end items-end">
            <div id="close-helen" onClick={() => toggleMenu(true)} className="mb-2">
              <div className="relative flex items-center h-12 justify-end">
                <div className="flex items-center justify-center w-12 h-12 bg-red-400 rounded-full">
                  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2454_32650)">
                      <path
                        d="M12.5299 25.0599C9.31994 25.0599 6.10994 23.8399 3.66994 21.3899C-1.22006 16.5099 -1.22006 8.54994 3.66994 3.66994C8.55994 -1.22006 16.5099 -1.22006 21.3999 3.66994C26.2899 8.55994 26.2899 16.5099 21.3999 21.3999C18.9599 23.8399 15.7499 25.0699 12.5399 25.0699L12.5299 25.0599ZM12.5299 1.50994C9.56994 1.50994 6.79994 2.64994 4.72994 4.72994C0.419941 9.02994 0.419941 16.0299 4.72994 20.3299C6.80994 22.3999 9.57994 23.5499 12.5299 23.5499C15.4799 23.5499 18.2599 22.4099 20.3299 20.3299C24.6299 16.0299 24.6299 9.02994 20.3299 4.71994C18.2499 2.64994 15.4799 1.49994 12.5299 1.49994V1.50994ZM15.8599 16.6099C15.6699 16.6099 15.4799 16.5399 15.3299 16.3899L12.5299 13.5899L9.72994 16.3899C9.43994 16.6799 8.95994 16.6799 8.66994 16.3899C8.37994 16.0999 8.37994 15.6199 8.66994 15.3299L11.4699 12.5299L8.66994 9.72994C8.37994 9.43994 8.37994 8.95994 8.66994 8.66994C8.95994 8.37994 9.43994 8.37994 9.72994 8.66994L12.5299 11.4699L15.3299 8.66994C15.6199 8.37994 16.0999 8.37994 16.3899 8.66994C16.6799 8.95994 16.6799 9.43994 16.3899 9.72994L13.5899 12.5299L16.3899 15.3299C16.6799 15.6199 16.6799 16.0999 16.3899 16.3899C16.2399 16.5399 16.0499 16.6099 15.8599 16.6099Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2454_32650">
                        <rect width="25.06" height="25.06" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </div>
            <a
              onClick={(event) => handleClick("whatsapp_web", event, true)}
              href="https://wa.me/34613259533"
              target="_blank"
              rel="nofollow"
              className="flex justify-end"
            >
              <div className="relative flex items-center h-12 justify-end bg-white rounded-full shadow-xl bg-opacity-95 w-fit">
                {/* <p className="pr-12 font-bold text-primary">WhatsApp</p> */}
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary">
                  <svg width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2454_32643)">
                      <path
                        d="M0.669933 19C0.489933 19 0.329933 18.93 0.199933 18.81C0.0299328 18.64 -0.0400672 18.39 0.0199328 18.17L1.12993 14.01C0.389933 12.62 -6.7226e-05 11.07 -6.7226e-05 9.5C-6.7226e-05 4.26 4.25993 0 9.49993 0C14.7399 0 18.9999 4.26 18.9999 9.5C18.9999 14.74 14.7399 19 9.49993 19C7.89993 19 6.33993 18.6 4.93993 17.84L0.839933 18.98C0.779933 19 0.729933 19.01 0.659933 19.01L0.669933 19ZM5.02993 16.46C5.13993 16.46 5.25993 16.5 5.36993 16.55C6.61993 17.28 8.04993 17.67 9.49993 17.67C13.9999 17.67 17.6699 14 17.6699 9.5C17.6699 5 13.9999 1.33 9.49993 1.33C4.99993 1.33 1.32993 5 1.32993 9.5C1.32993 10.94 1.70993 12.34 2.42993 13.58C2.51993 13.73 2.53993 13.92 2.49993 14.08L1.61993 17.38L4.86993 16.48C4.91993 16.46 4.97993 16.45 5.03993 16.45L5.02993 16.46Z"
                        fill="white"
                      />
                      <path
                        d="M10.3099 13.9799C9.76991 13.7499 9.22991 13.4399 8.70991 13.0499C8.18991 12.6699 7.67991 12.2299 7.20991 11.7699C6.73991 11.2899 6.30991 10.7899 5.92991 10.2699C5.53991 9.72994 5.22991 9.18994 5.00991 8.67994C4.76991 8.11994 4.65991 7.57994 4.65991 7.06994C4.65991 6.70994 4.71991 6.36994 4.84991 6.05994C4.97991 5.73994 5.17991 5.43994 5.45991 5.17994C5.96991 4.67994 6.66991 4.51994 7.19991 4.77994C7.36991 4.85994 7.51991 4.97994 7.63991 5.15994L8.65991 6.59994C8.74991 6.71994 8.81991 6.84994 8.87991 6.98994C8.93991 7.14994 8.97991 7.28994 8.97991 7.41994C8.97991 7.59994 8.92991 7.78994 8.82991 7.94994C8.75991 8.06994 8.65991 8.20994 8.51991 8.33994L8.40991 8.45994L8.26991 8.60994L8.39991 8.77994C8.39991 8.77994 8.41991 8.79994 8.41991 8.80994C8.46991 8.86994 8.52991 8.95994 8.61991 9.05994C8.80991 9.26994 9.00991 9.50994 9.23991 9.72994C9.45991 9.93994 9.67991 10.1599 9.90991 10.3499C10.0099 10.4399 10.1199 10.5199 10.1999 10.5699L10.3699 10.6799L10.5099 10.5399L10.6299 10.4199C10.7799 10.2699 10.9099 10.1699 11.0399 10.0999H11.0499L11.0599 10.0899C11.2799 9.94994 11.6399 9.90994 11.9699 10.0499C12.0899 10.0899 12.2099 10.1599 12.3499 10.2599L13.8299 11.2999C13.9899 11.4099 14.1199 11.5699 14.2099 11.7499C14.2799 11.9399 14.3099 12.0999 14.3099 12.2699C14.3099 12.4899 14.2599 12.7099 14.1599 12.9299C14.0499 13.1399 13.9299 13.3199 13.7899 13.4899C13.5299 13.7699 13.2399 13.9799 12.9199 14.1099C12.5999 14.2499 12.2499 14.3099 11.8999 14.3099C11.3899 14.3099 10.8599 14.1999 10.2899 13.9499L10.3099 13.9799ZM6.79991 5.52994L6.73991 5.48994H6.65991C6.65991 5.48994 6.52991 5.48994 6.40991 5.52994C6.28991 5.56994 6.15991 5.64994 6.02991 5.77994C5.83991 5.95994 5.70991 6.15994 5.60991 6.36994C5.50991 6.58994 5.46991 6.83994 5.46991 7.07994C5.46991 7.48994 5.56991 7.91994 5.74991 8.36994C5.93991 8.82994 6.22991 9.31994 6.56991 9.79994C6.91991 10.2799 7.31991 10.7499 7.75991 11.1999C8.19991 11.6299 8.66991 12.0399 9.15991 12.3999C9.62991 12.7499 10.1199 13.0199 10.5999 13.2299C11.2999 13.5299 11.9999 13.6299 12.5899 13.3799C12.8099 13.2899 12.9999 13.1399 13.1699 12.9699C13.2599 12.8699 13.3399 12.7599 13.4099 12.6199C13.4499 12.5299 13.4699 12.4199 13.4699 12.3199C13.4699 12.3199 13.4699 12.2699 13.4699 12.2299C13.4699 12.1899 13.4499 12.1499 13.4299 12.1099L13.3999 12.0499L13.3499 12.0099L11.8799 10.9899C11.8099 10.9399 11.7199 10.8899 11.6399 10.8599L11.5399 10.8299L11.4499 10.8799C11.3899 10.9099 11.3199 10.9499 11.1999 11.0699L10.8599 11.4099C10.6799 11.5899 10.3799 11.6499 10.1399 11.5699L9.99991 11.5099C9.81991 11.4099 9.60991 11.2699 9.36991 11.0599C9.12991 10.8499 8.88991 10.6399 8.63991 10.3899C8.39991 10.1399 8.17991 9.89994 7.96991 9.65994C7.74991 9.39994 7.59991 9.19994 7.50991 9.02994L7.41991 8.82994C7.40991 8.77994 7.39991 8.70994 7.39991 8.63994C7.39991 8.45994 7.45991 8.29994 7.58991 8.16994L7.91991 7.82994C8.02991 7.71994 8.07991 7.64994 8.11991 7.57994L8.16991 7.47994L8.11991 7.36994C8.07991 7.27994 8.02991 7.20994 7.98991 7.14994L6.95991 5.68994L6.92991 5.64994L6.88991 5.61994L6.77991 5.54994L6.79991 5.52994Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2454_32643">
                        <rect width="22" height="22" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </div>
            </a>
            {isPostPage && (
              <a
                href="#post-form"
                className=" relative flex md:hidden items-center h-12 pl-4 bg-white rounded-full shadow-xl bg-opacity-95 px-9"
              >
                <p className="pr-12 font-bold text-primary">¿Qué quieres alquilar?</p>
                <div className="absolute right-0 flex items-center justify-center w-12 h-12 rounded-full bg-primary">
                  <svg width="156" height="151" viewBox="0 0 156 151" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="78.3139" cy="75.5" rx="77.476" ry="75.5" fill="#58A291" />
                    <path
                      d="M71.84 104.828C71.84 103.641 71.8087 103.594 70.637 103.594C66.2784 103.594 61.9354 103.579 57.5767 103.61C56.7487 103.61 56.4831 103.329 56.4988 102.516C56.5144 82.8632 56.5144 63.2102 56.4988 43.5572C56.4988 42.7292 56.78 42.4636 57.5923 42.4792C65.7629 42.5105 73.9178 42.4949 82.0727 42.4949C83.26 42.4949 83.2756 42.5105 83.2756 43.7134V60.1013C83.2756 61.5386 83.2756 61.5386 84.666 61.5386C90.1807 61.5386 95.711 61.5542 101.226 61.523C102.147 61.523 102.413 61.8198 102.397 62.7103C102.351 65.8035 102.382 73.3491 102.382 73.3491L102.882 72.8492C105.069 70.6621 107.256 68.4906 109.412 66.2722C109.693 65.9285 109.849 65.5067 109.849 65.0692C109.896 63.0071 109.849 60.9293 109.881 58.8515C109.912 58.1641 109.646 57.4924 109.131 57.0237C106.209 54.1492 103.319 51.2278 100.413 48.3376C96.1797 44.0571 91.9304 39.8078 87.6655 35.5741C87.3374 35.2461 86.9 35.0586 86.4313 35.0117C76.3548 34.9961 66.2628 34.9961 56.1863 35.0117C54.3116 35.0117 52.7025 35.7928 51.3434 37.0583C49.5624 38.7455 49 40.8545 49 43.2447C49.0156 63.0852 49.0312 82.91 49.0156 102.751C49.0156 103.11 49.0156 103.469 49.0312 103.828C49.25 107.875 52.2807 111.03 56.1863 111.077C61.1074 111.155 66.0284 111.093 70.9495 111.124C71.6681 111.124 71.8712 110.827 71.8556 110.156C71.8087 108.375 71.84 106.609 71.84 104.828Z"
                      fill="white"
                    />
                    <path
                      d="M67.9974 73.021H90.8843C92.9933 73.021 94.6961 74.7239 94.6961 76.8329C94.6961 78.9419 92.9933 80.6448 90.8843 80.6448H67.9974C65.8884 80.6448 64.1855 78.9419 64.1855 76.8329C64.1855 74.7239 65.8884 73.021 67.9974 73.021Z"
                      fill="white"
                    />
                    <path
                      d="M67.9974 88.2841H79.5268C81.6358 88.2841 83.3386 89.987 83.3386 92.096C83.3386 94.205 81.6358 95.9079 79.5268 95.9079H67.9974C65.8884 95.9079 64.1855 94.205 64.1855 92.096C64.1855 89.987 65.8884 88.2841 67.9974 88.2841Z"
                      fill="white"
                    />
                    <path
                      d="M114.63 90.5963L114.615 90.5807L103.929 80.8167C103.929 80.8167 92.0403 93.8458 86.3069 100.251C85.5882 101.048 85.0727 102.141 84.7915 103.172C83.9479 106.234 83.2605 109.343 82.495 112.421C82.2919 113.249 82.37 113.967 83.0418 114.545C83.6667 115.092 84.354 115.092 85.1195 114.827C87.9784 113.827 90.853 112.858 93.7431 111.905C95.2273 111.405 96.5395 110.515 97.5706 109.343C102.992 103.313 114.63 90.5963 114.63 90.5963Z"
                      fill="white"
                    />
                    <path
                      d="M120.019 77.5984L116.363 74.2553C114.411 72.4743 111.38 72.6149 109.599 74.5677L105.818 78.7076L116.551 88.5029L120.332 84.3473C122.113 82.4102 121.972 79.3794 120.019 77.5984Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </a>
            )}
            <a
              onClick={(event) => handleClick("llamada_web", event)}
              href="tel:+34911935181"
              target="_blank"
              className="relative flex items-center h-12 justify-end bg-white rounded-full shadow-xl bg-opacity-95 w-fit"
            >
              {/* <p className="pr-12 font-bold text-primary">911 935 181</p> */}
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary">
                <svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2454_32658)">
                    <path
                      d="M12.98 17.33C12.07 17.33 11.1 17.12 10.11 16.69C9.14 16.28 8.18 15.72 7.24 15.04C6.29 14.34 5.39 13.57 4.56 12.75C3.73 11.92 2.96 11.02 2.27 10.07C1.58 9.10999 1.03 8.14999 0.63 7.21999C0.21 6.22999 0 5.25999 0 4.33999C0 3.69999 0.11 3.09999 0.34 2.52999C0.57 1.93999 0.94 1.39999 1.43 0.93999C2.07 0.30999 2.8 -0.0100098 3.59 -0.0100098C3.93 -0.0100098 4.26 0.0599902 4.56 0.20999C4.89 0.35999 5.17 0.59999 5.38 0.89999L7.21 3.47999C7.38 3.71999 7.51 3.94999 7.61 4.17999C7.72 4.42999 7.78 4.69999 7.78 4.94999C7.78 5.27999 7.69 5.59999 7.51 5.89999C7.39 6.11999 7.2 6.35999 6.95 6.59999L6.49 7.07999C6.59 7.23999 6.77 7.49999 7.09 7.87999C7.43 8.26999 7.8 8.67999 8.2 9.08999C8.6 9.48999 9 9.85999 9.41 10.21C9.78 10.53 10.05 10.71 10.22 10.8L10.69 10.34C10.95 10.08 11.19 9.88999 11.44 9.76999C11.9 9.48999 12.51 9.42999 13.12 9.67999C13.34 9.76999 13.56 9.88999 13.81 10.06L16.44 11.93C16.75 12.15 16.99 12.42 17.13 12.75C17.26 13.08 17.32 13.37 17.32 13.67C17.32 14.08 17.23 14.47 17.05 14.85C16.88 15.22 16.66 15.54 16.39 15.84C15.92 16.36 15.4 16.73 14.82 16.96C14.26 17.2 13.64 17.32 12.99 17.32L12.98 17.33ZM3.59 1.49999C3.2 1.49999 2.83 1.66999 2.47 2.02999C2.13 2.34999 1.88 2.70999 1.73 3.08999C1.58 3.47999 1.5 3.89999 1.5 4.33999C1.5 5.05999 1.67 5.82999 2.01 6.63999C2.36 7.46999 2.85 8.32999 3.48 9.18999C4.12 10.07 4.84 10.91 5.61 11.69C6.38 12.46 7.23 13.18 8.12 13.83C8.97 14.45 9.83 14.95 10.7 15.31C12.01 15.87 13.24 16 14.24 15.58C14.62 15.42 14.96 15.18 15.27 14.83C15.44 14.64 15.57 14.44 15.69 14.21C15.77 14.03 15.82 13.85 15.82 13.67C15.82 13.56 15.8 13.46 15.75 13.33C15.75 13.31 15.7 13.24 15.58 13.16L12.95 11.29C12.8 11.19 12.67 11.11 12.55 11.06C12.41 11 12.38 10.95 12.18 11.06C12.06 11.12 11.93 11.21 11.75 11.39L11.14 11.99C10.8 12.33 10.25 12.42 9.83 12.26L9.6 12.16C9.27 11.98 8.88 11.71 8.45 11.34C8.02 10.97 7.59 10.57 7.15 10.14C6.72 9.69999 6.33 9.26999 5.96 8.84999C5.58 8.39999 5.3 8.00999 5.13 7.69999L5.02 7.44999C4.96 7.23999 4.95 7.11999 4.95 6.99999C4.95 6.66999 5.07 6.37999 5.3 6.14999L5.89 5.52999C6.08 5.33999 6.17 5.19999 6.22 5.11999C6.27 5.03999 6.29 4.97999 6.29 4.92999C6.29 4.89999 6.28 4.82999 6.24 4.73999C6.19 4.60999 6.11 4.47999 6 4.32999L4.16 1.73999C4.1 1.64999 4.02 1.58999 3.93 1.53999C3.83 1.48999 3.72 1.46999 3.6 1.46999L3.59 1.49999Z"
                      fill="white"
                    />
                    <path
                      d="M16.58 7.04C16.17 7.04 15.83 6.7 15.83 6.29C15.83 3.65 13.68 1.5 11.04 1.5C10.63 1.5 10.29 1.16 10.29 0.75C10.29 0.34 10.63 0 11.04 0C14.51 0 17.33 2.82 17.33 6.29C17.33 6.7 16.99 7.04 16.58 7.04ZM13.81 7.04C13.4 7.04 13.06 6.7 13.06 6.29C13.06 6.08 12.83 5.53 12.34 5.01C11.91 4.55 11.43 4.27 11.04 4.27C10.63 4.27 10.29 3.93 10.29 3.52C10.29 3.11 10.63 2.77 11.04 2.77C11.85 2.77 12.72 3.21 13.43 3.98C13.97 4.56 14.56 5.48 14.56 6.29C14.56 6.7 14.22 7.04 13.81 7.04Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2454_32658">
                      <rect width="17.33" height="17.33" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </a>
            <a
              href="mailto:hola&#64;elalquilador&#46;com"
              className="relative flex items-center h-12 justify-end bg-white rounded-full shadow-xl bg-opacity-95 w-fit"
            >
              {/* <p className="pr-12 font-bold text-primary">hola&#64;elalquilador&#46;com</p> */}
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary">
                <svg width="24" height="24" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clipPath="url(#clip0_2454_32654)">
                    <path
                      d="M8.67 14.96H4.71C1.72 14.96 0 13.24 0 10.25V4.71C0 1.72 1.72 0 4.71 0H12.63C15.62 0 17.34 1.72 17.34 4.71V7.09C17.34 7.5 17 7.84 16.59 7.84C16.18 7.84 15.84 7.5 15.84 7.09V4.71C15.84 2.55 14.79 1.5 12.63 1.5H4.71C2.55 1.5 1.5 2.55 1.5 4.71V10.25C1.5 12.41 2.55 13.46 4.71 13.46H8.67C9.08 13.46 9.42 13.8 9.42 14.21C9.42 14.62 9.08 14.96 8.67 14.96Z"
                      fill="white"
                    />
                    <path
                      d="M11.69 15.3699C11.35 15.3699 11.03 15.2399 10.79 15.0099C10.51 14.7299 10.38 14.3299 10.44 13.9099L10.59 12.8399C10.64 12.5199 10.82 12.1699 11.04 11.9499L13.84 9.14989C14.74 8.24989 15.76 8.24989 16.65 9.14989C17.15 9.63989 17.37 10.1699 17.31 10.7199C17.27 11.1599 17.05 11.5699 16.65 11.9699L13.85 14.7699C13.62 15.0199 13.24 15.1799 12.97 15.2199L11.89 15.3699C11.82 15.3699 11.75 15.3799 11.69 15.3799V15.3699ZM14.9 10.1999L12.1 12.9999L11.97 13.8199L12.75 13.7099L15.59 10.8799C15.8 10.6799 15.82 10.5699 15.82 10.5399C15.82 10.4899 15.77 10.3599 15.59 10.1799C15.42 10.0099 15.3 9.93989 15.24 9.94989C15.21 9.94989 15.11 9.97989 14.9 10.1799V10.1999ZM8.65998 8.31989C7.95998 8.31989 7.25999 8.09989 6.70999 7.66989L4.23998 5.68989C3.91998 5.42989 3.85998 4.95989 4.11998 4.63989C4.37998 4.31989 4.84999 4.25989 5.16999 4.51989L7.63998 6.49989C8.17998 6.92989 9.12998 6.92989 9.66998 6.49989L12.15 4.51989C12.47 4.25989 12.95 4.31989 13.2 4.63989C13.46 4.95989 13.41 5.43989 13.08 5.68989L10.6 7.66989C10.05 8.10989 9.34998 8.31989 8.64998 8.31989H8.65998Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2454_32654">
                      <rect width="17.33" height="15.37" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </a>
          </div>
        )}

        <div
          id="open-helen"
          onClick={() => toggleMenu(true)}
          className={`flex justify-end flex-col gap-3 mt-6 ${shakeAnimation ? "animate-shake" : ""}`}
        >
          {showMessage && (
            <div
              className={`bg-white px-6 py-2 rounded-full transition-all translate-x-0 opacity-1 ${
                showMessage ? "translate-x-0 opacity-1" : "translate-x-4 opacity-0"
              }`}
            >
              <p className="whitespace-nowrap text-primary font-bold">¿Puedo ayudarte?</p>
            </div>
          )}
          <img
            src={AvatarImage}
            className="self-end w-20 h-20 transition-all duration-300 rounded-full shadow-2xl hover:scale-110 md:h-24 md:w-24"
            alt="Asistenta Virtual elgestionador"
          />
        </div>
      </div>
    </section>
  );
}
export default AssistantAvatar;
